import { Auth } from 'aws-amplify';

const getAxiosAuthHeaders = async (existingHeaders = {}) => {
  const jwt = (await Auth.currentSession()).getAccessToken().getJwtToken();
  const idJwt = (await Auth.currentSession()).getIdToken().getJwtToken();
  return {
    ...existingHeaders,
    Authorization: `Bearer: ${jwt}`,
    'X-Id-Authorization': idJwt,
  };
};

export default getAxiosAuthHeaders;
